'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactJss = require('react-jss');
var THEME = require('pobble-components/dist/theme');
var injectSheet = require('react-jss/lib/injectSheet');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var CSSVars = injectSheet__default["default"]({
  '@global': {
    ':root': {
      '--blue': '#00afec',
      '--blue-': '#54bef2',
      '--blue--': '#9ad7f7',
      '--green': '#a0be17',
      '--green-': '#b3ca54',
      '--green--': '#d0df98',
      '--darkBlue': '#25408f',
      '--darkBlue-': '#5165a5',
      '--darkBlue--': '#92a0c8',
      '--red': '#e94d23',
      '--red-': '#ef7354',
      '--red--': '#f7a996',
      '--purple': '#815fa5',
      '--purple-': '#9a7fb8',
      '--purple--': '#c1b0d2',
      '--yellow': '#fee433',
      '--yellow-': '#fee966',
      '--yellow--': '#fff2a3',
      '--gray': '#333333',
      '--gray-': '#555555',
      '--gray--': '#777777',
      '--gray---': '#999999',
      '--lightGray': '#ececec',
      '--lightGray-': '#f0f0f0',
      '--lightGray--': '#f6f6f6',
      '--bluegray': 'hsl(196deg 100% 3%)',
      '--bluegray-': 'hsl(196deg 30% 9%)',
      '--bluegray--': 'hsl(196deg 20% 16%)',
      '--bluegray---': 'hsl(196deg 26% 24%)',
      '--body': "16px/20px ".concat(THEME__default["default"].FONTS.MAIN),
      '--body-': "14px/17px ".concat(THEME__default["default"].FONTS.MAIN),
      '--body--': "12px/15px ".concat(THEME__default["default"].FONTS.MAIN),
      '--body---': "10px/12px ".concat(THEME__default["default"].FONTS.MAIN),
      '--heading_': "bold 34px/38px ".concat(THEME__default["default"].FONTS.MAIN),
      '--heading': "bold 26px/30px ".concat(THEME__default["default"].FONTS.MAIN),
      '--heading-': "bold 22px/26px ".concat(THEME__default["default"].FONTS.MAIN),
      '--heading--': "bold 18px/20px ".concat(THEME__default["default"].FONTS.MAIN),
      '--heading---': "bold 16px/20px ".concat(THEME__default["default"].FONTS.MAIN)
    }
  }
})(function (_ref) {
  var children = _ref.children;
  return children;
});
var GlobalStyles = injectSheet__default["default"]({
  '@global': {
    body: {
      '-webkit-font-smoothing': 'antialiased',
      backgroundColor: '#F8F8F8',
      font: "".concat(THEME__default["default"].FONT_SIZES.BODY_DEFAULT.COMBINATION, " ").concat(THEME__default["default"].FONTS.MAIN),
      color: THEME__default["default"].COLORS.TEXT.DARK_GREY.NORMAL
    },
    '*': {
      boxSizing: 'border-box',
      '&:focus': {
        outline: 'none'
      }
    },
    h1: THEME__default["default"].FONT_SIZES.HEADING_EXTRA_LARGE.STYLE,
    h2: THEME__default["default"].FONT_SIZES.HEADING_LARGE.STYLE,
    h3: THEME__default["default"].FONT_SIZES.HEADING_BIG.STYLE,
    h4: THEME__default["default"].FONT_SIZES.HEADING_MEDIUM.STYLE,
    h5: THEME__default["default"].FONT_SIZES.HEADING_DEFAULT.STYLE,
    h6: THEME__default["default"].FONT_SIZES.HEADING_SMALL.STYLE,
    'input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '.h-screen-header': {
      height: 'calc(100vh - 70px)',
      '@media (max-width: 768px)': {
        height: 'calc(100vh - 50px)'
      }
    }
  }
})(function (_ref2) {
  var children = _ref2.children;
  return children;
});
var PobbleStyles = function PobbleStyles(_ref3) {
  var children = _ref3.children,
      noGlobalStyles = _ref3.noGlobalStyles;
  return /*#__PURE__*/React__default["default"].createElement(reactJss.ThemeProvider, {
    theme: THEME__default["default"]
  }, /*#__PURE__*/React__default["default"].createElement(CSSVars, null, noGlobalStyles ? children : /*#__PURE__*/React__default["default"].createElement(GlobalStyles, null, children)));
};

exports.CSSVars = CSSVars;
exports.GlobalStyles = GlobalStyles;
exports.PobbleStyles = PobbleStyles;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/styles/index.js